var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-theme-provider',{attrs:{"dark":_vm.dark,"light":!_vm.dark,"root":""}},[_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }